import React from 'react';
import loadable from '@loadable/component';

import DefaultContentTemplate from './templates/default-pdp-template';
import { withProductConsumer } from '../../../context/product/product-context';
import withDeviceChange from '../../../ui/components/device-change';

const PUFContentTemplate = loadable(() => import('./templates/puf-pdp-template'));

const PDPMainBlock = ({productContext,device}) => {
    if(!productContext)return null;
    const { template } = productContext;
    switch(template) {
    case "pdp-puf":
		return(
            <PUFContentTemplate device={device} {...productContext}/>
        )
    default:
        return(
            <DefaultContentTemplate device={device} {...productContext}/>
        )
    }
};

export default withDeviceChange(withProductConsumer(PDPMainBlock));
